<template>
    <v-container class="pa-0" fluid>
        <v-layout row>
            <v-flex>
                <v-btn-toggle
                    class="rounded-btn-group v-text-field--outline"
                    mandatory 
                    :value="selectedValue" 
                    @change="handleValueChanged">
                    <v-flex v-for="(mode, index) in modes" :key="index" class="pa-0" xs6>
                        <v-btn flat block>
                            <span>{{ mode.name }}</span>
                        </v-btn>
                    </v-flex>
                </v-btn-toggle>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ForecastingOverviewCalendarModes from '@/helpers/forecastingOverviewCalendarModes'

export default {
    components: {

    },
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    data(){
        return {
            weekOffsetTop: 0,
            dayOffSetTop: 0
        };
    },
    computed: {
        modes(){
            return Object.keys(ForecastingOverviewCalendarModes).map(x => {
                if(ForecastingOverviewCalendarModes[x] === ForecastingOverviewCalendarModes.Week){
                    return {
                        name: "Week"
                    };
                }

                if(ForecastingOverviewCalendarModes[x] === ForecastingOverviewCalendarModes.Day){
                    return {
                        name: "Day"
                    };
                }
            });
        },
        selectedValue(){
            return Object.keys(ForecastingOverviewCalendarModes).findIndex(
                x => ForecastingOverviewCalendarModes[x] === this.value
            );
        }
    },
    methods: {
        handleValueChanged(value){
            let modeSelected = Object.keys(ForecastingOverviewCalendarModes)[value];    
            this.update(ForecastingOverviewCalendarModes[modeSelected]);
        },
        update(value){
            this.$emit("input", value);
        }
    }
}
</script>

<style scoped>
.rounded-btn-group {
    border-radius: 4px;
    border: 2px solid rgba(0,0,0,0.54);
    margin-bottom: 0px;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.rounded-btn-group .v-btn {
    padding: 16px 20px;
    height: 56px;
    width: 100%;
}

.rounded-btn-group:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.rounded-btn-group:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
</style>